module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fmcy-menu-item-price-quantity fmcy-menu-item-price-quantity-check">\n    ';
 if (quantity !== '1') { 
__p+='\n    '+
((__t=( quantity ))==null?'':__t)+
'\n    ';
 } else { 
__p+='\n      ONE\n    ';
 } 
__p+='\n    <div class="fmcy-menu-item-price-quantity-check-mark"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg></div>\n    <div class="fmcy-menu-item-price-quantity-out-of-stock-icon-region"></div>\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/menu-item-prices/menu-item-price/menu-item-price-check.html
 ** module id = 119
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 16 17 22 25 26 87 98 173
 **/